import { steps } from "../../util/Constants";
import { StepCard } from "./StepCard";

interface Props {
    className?: string;
}

export default function DashboardPreviewSection({
    className = "",
}: Props) {
    return (
        <section className={`bg-web-background flex flex-col gap-28 ${className}`}>

            {/* automation steps */}
            <div className="z-10 mx-auto flex w-full max-w-7xl flex-col">
                <div className="mb-5 flex items-center gap-3">
                    <div className="h-px w-12 bg-web-primary" />
                    <span className="text-xs font-medium uppercase tracking-[0.3em] text-web-primary">
                        How it works
                    </span>
                </div>

                <h2 className="max-w-5xl text-4xl font-bold leading-tight text-white md:text-6xl">
                    Three steps to{" "}
                    <span className="text-web-primary">
                        automation.
                    </span>
                </h2>

                <div className="relative md:mt-20 mt-12 lg:px-16">
                    {/* connector line */}
                    <div className="absolute hidden md:block top-7 left-[17%] right-[17%]">
                        <img src="/images/Divider.svg" alt="" className="w-full" />
                    </div>

                    <div className="grid md:gap-16 gap-10 md:grid-cols-3">
                        {steps.map((item) => (
                            <StepCard
                                key={item.title}
                                icon={item.icon}
                                step={item.step}
                                title={item.title}
                                description={item.description}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* dashboard preview */}
            <div className="z-10 mx-auto flex max-w-7xl flex-col items-center text-center">

                <div className="mb-5 flex items-center gap-3">
                    <div className="h-px w-12 bg-web-primary" />
                    <span className="text-xs font-medium uppercase tracking-[0.3em] text-web-primary">
                        One Command Center
                    </span>
                </div>

                <h2 className="max-w-5xl text-4xl font-bold leading-tight text-white md:text-5xl">
                    Everything in one{" "}
                    <span className="text-web-primary">
                        dashboard.
                    </span>
                </h2>

                <p className="mt-5 max-w-3xl text-base text-white/70">
                    Built for marketing teams, developers, and growth operators.
                </p>

                <div className="mt-14 w-full">
                    <div className="overflow-hidden ">
                        <img
                            src="/images/dashboardimage.svg"
                            alt="Dashboard Preview"
                            className="w-full object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}